import LoadsFilters from './loads-filters';

export default LoadsFilters;
